import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { QuestionDetailTabsComponent } from '../question-detail-tabs/question-detail-tabs.component';

@Component({
  selector: 'app-question-detail-modal',
  standalone: true,
  imports: [CommonModule, NgIf, QuestionDetailTabsComponent],
  templateUrl: './question-detail-modal.component.html',
  styleUrl: './question-detail-modal.component.css'
})
export class QuestionDetailModalComponent {
  @Input() open: boolean = false;
  @Input() questionId: number | null = null;
  // Optional: provide HTML + answers directly (used by Search / Flagged lists)
  // so the question tab can render without depending on "current test" state.
  @Input() questionHtml: string | null = null;
  @Input() answersHtml: Array<string | null> = [];
  @Input() correctAnswer: string | null = null;
  @Input() initialTab: 'question' | 'explanation' | 'note' | 'exam' | 'comments' = 'question';

  @Output() closed = new EventEmitter<void>();

  close() {
    this.closed.emit();
  }
}

